// "View Other Features" toggle: shows/hides the extra 1x cards appended to the
// features grid (the .features__more display:contents wrapper). Newly shown cards
// scroll-reveal on their own — they already carry .reveal from initScrollReveal.

export function initFeaturesToggle(): void {
  const toggle = document.querySelector<HTMLButtonElement>('[data-more-toggle]');
  const more = document.getElementById('more-features');
  if (!toggle || !more) return;

  toggle.addEventListener('click', () => {
    const expand = more.hidden;
    more.hidden = !expand;
    toggle.setAttribute('aria-expanded', String(expand));
    toggle.textContent = expand ? 'Hide Other Features' : 'View Other Features';
  });
}
